import { cineamoApiClient } from '../../apiClient';
import { TicketPurchaseIntentDto } from '../../models/ticket-purchase-intent/TicketPurchaseIntentDto';
import { TicketPurchaseIntentInputDto } from '../../models/ticket-purchase-intent/TicketPurchaseIntentInputDto.types';
import { ApiErrorResponse } from '../../types/ApiErrorResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

// <------------------------ Create Ticket Purchase Intent ------------------------>

/**
 * This endpoint creates a Ticket Purchase Intent Dto.
 *
 * @example
 * createTicketPurchaseIntent({...data});
 *
 * @param data
 * @returns {ApiResponse<TicketPurchaseIntentDto> | ApiErrorResponse<TicketPurchaseIntentInputDto>}
 */

export function createTicketPurchaseIntent(
    data: TicketPurchaseIntentInputDto
): Promise<ApiResponse<TicketPurchaseIntentDto> | ApiErrorResponse<TicketPurchaseIntentInputDto>> {
    return cineamoApiClient
        .post('/ticket-purchase-intents', data)
        .then((res) => res.data)
        .catch((error) => error);
}
